import json from 'country-region-data/data.json';

const countriesToIgnore = ['United States Minor Outlying Islands'];
const statesToIgnore = [
  'Armed Forces Americas',
  'Armed Forces Europe, Canada, Africa and Middle East',
  'Armed Forces Pacific',
  'American Samoa',
  'Micronesia',
  'Guam',
  'Marshall Islands',
  'Northern Mariana Islands',
  'Virgin Islands',
  'Puerto Rico',
  'Palau',
];

export const countriesToRegionsMap = new Map(
  json.reduce((entries, currentCountry) => {
    if (!countriesToIgnore.includes(currentCountry.countryName)) {
      if (currentCountry.countryName === 'United States') {
        entries.push([
          currentCountry.countryName,
          currentCountry.regions.filter((r) => !statesToIgnore.includes(r.name)).map((o) => o.name),
        ]);
      } else {
        entries.push([currentCountry.countryName, currentCountry.regions.map((r) => r.name)]);
      }
    }
    return entries;
  }, [])
);

const fields = {
  firstName: 'first_name',
  lastName: 'last_name',
  email: 'email',
  stripeToken: 'stripe_token',
  billingAddress: 'stripe_billing_address',
  billingCountry: 'stripe_billing_address.country',
  billingProvince: 'stripe_billing_address.province',
  billingCity: 'stripe_billing_address.city',
  billingLine1: 'stripe_billing_address.line1',
  billingLine2: 'stripe_billing_address.line2',
  billingPostalCode: 'stripe_billing_address.postal_code',
  hasAcceptedTerms: 'has_accepted_terms',
  orderId: 'order_code',
  subscriptionCreditCode: 'subscription_credit_claim_code',
  purchaseSource: 'purchase_source',
  orderType: 'order_type',
};

export const purchaseSources = [
  { name: 'Tempo.fit', value: 'tempo', default: true },
  { name: 'Best Buy', value: 'bestbuy' },
  { name: 'Received as a gift', value: 'gift' },
  { name: 'Outside of the US', value: 'outside_us' },
  { name: 'Other', value: 'other' },
];
export const InternationalRegisterPurchaseSources = [
  { name: 'www.tempofit.me', value: 'www.tempofit.me', default: true },
];

export const orderTypes = [
  { name: 'Tempo Studio', value: 'studio' },
  { name: 'Tempo Move', value: 'move' },
  { name: 'Tempo Core', value: 'core' },
];

export default fields;
